"use client";

import { Check } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhyChooseAAEaglePlumbing() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const benefits = [{
    id: 1,
    text: "Specialized Water Pump Expertise"
  }, {
    id: 2,
    text: "Fast Emergency Pump Repairs"
  }, {
    id: 3,
    text: "Certified Pump Technicians"
  }, {
    id: 4,
    text: "All Pump Types & Brands Serviced"
  }, {
    id: 5,
    text: "Reliable Installation & Maintenance"
  }];
  return <section ref={sectionRef} className="bg-dark-background text-foreground-dark py-16 md:py-24">
      <div className="container mx-auto px-6 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {}
          <div className="space-y-8">
            <h2 className={`font-display text-3xl md:text-4xl font-bold text-foreground transition-all duration-[350ms] ease-[var(--ease-smooth)] ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              Why Choose AA Eagle Plumbing for Water Pumps
            </h2>

            <ul className="space-y-4">
              {benefits.map((benefit, i) => <li key={benefit.id} data-index={i} className={`flex items-start gap-3 transition-all duration-[350ms] ease-[var(--ease-smooth)] ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
              transitionDelay: sectionVisible ? `${(i + 1) * 100}ms` : "0ms"
            }}>
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-secondary flex items-center justify-center mt-0.5">
                    <Check className="w-4 h-4 text-foreground-secondary" />
                  </div>
                  <span className="text-foreground-dark text-base md:text-lg">
                    {benefit.text}
                  </span>
                </li>)}
            </ul>
          </div>

          {}
          <div className={`relative overflow-hidden rounded-xl shadow-medium transition-all duration-[350ms] ease-[var(--ease-smooth)] ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: sectionVisible ? "300ms" : "0ms"
        }}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521681/img/completed_plumbing_project_installation.png" alt="Completed water pump installation showcasing AA Eagle Plumbing's quality workmanship" className="w-full h-auto object-cover aspect-[4/3]" />
          </div>
        </div>
      </div>
    </section>;
}